import ExportModule from './export';

var UNDEF,
    isChartAPI = function isChartAPI(a) {
  return 'chartAPI' === a.getType();
};

function exportChart() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var b = this.apiInstance.getChildren('exportModule');
  return b = b && b[0], b !== UNDEF && (b.exportChart(a), !0);
}

function exporter(a) {
  a.addEventListener('instantiated', function (a) {
    var b = a.sender;
    isChartAPI(b) && b.registerFactory('export', function (a) {
      var c,
          d = b.getFromEnv('chartInstance');
      d.exportChart = exportChart, !a.getChildren('export') && +a.getFromEnv('dataSource').chart.exportenabled && (c = new ExportModule(), a.attachChild(c, 'exportModule'), c.addToEnv('chartInstance', a.getFromEnv('chartInstance')), c.addToEnv('chartMenuList', a.getFromEnv('chartMenuList')), c.configure({
        chartConfig: a.getFromEnv('dataSource').chart
      })), a.getChildren('export') && c && c.configure({
        chartConfig: a.getFromEnv('dataSource').chart
      });
    });
  });
}

export default {
  extension: exporter,
  name: 'Export',
  type: 'extension',
  requiresFusionCharts: !0
};